import React, { useState } from 'react';
import { Row, Col, Container } from 'react-bootstrap';
import InternalMsg from './InternalMsg';
import EmailMsg from './EmailMsg';
import Loading from '../Loading';

const Communication = () => {
  const [loading, setLoading] = useState(false);

  return (
    <section className="section-spaces">
      <Container>
        <Row>
          <Col>
            <h3 className="mb-5">
              Send Message/Email to a Group
            </h3>
          </Col>
        </Row>
        <Row>
          <Col lg={6} className="d-flex">
            <InternalMsg 
              setLoading={setLoading}
            />
          </Col>
          <Col lg={6} className="d-flex">
            <EmailMsg 
              setLoading={setLoading}
            />
          </Col>
        </Row>
      </Container>  
      {loading && <Loading />}
    </section>  
  )
}

export default Communication;